import { useState, useEffect } from 'react';



import { Box, Button, CircularProgress, Modal, TextField, Select, MenuItem, FormControl, FormHelperText, Grid } from '@mui/material';

import { useEditTransactionAdjustmentMutation, useGetTransactionsQuery } from '../../../../../services/PaymentToolApi';

import { createErrorMessage } from '../../../../../utils/index';

import { useGetTransactionTypesQuery } from '../../../../../services/PaymentToolApi';

import { useNotification } from '../../../../../context/NotificationContext';

import { createAddTransactionValidationSchema } from '../../../../../validations/PaymentTool/addNewTransactionValidation';
import {useRequestTypeQuery} from '../../../../../services/jobsApi';


const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
}

//selectedTransaction example:
// {
//   "amount": 66,
//   "reward": "",
//   "relatedTransactionID": null,
//   "transactionType": "Deduction",
//   "comments": "123",
//   "buyType": null,
//   "eventName": null,
//   "date": "2024-01-22T18:42:37.5239202",
//   "transactionID": 439806,
//   "period": "01/22/2024-01/28/2024",
//   "year": 2024,
//   "userID": 1,
//   "linkedStnPurchaseID": 1,
// }

// This modal only handles transactions of type Reward, Deduction, Bonus, Royalty
// Penalty transactions are handled by EditErrorTransactionModal
const PRE_POPULATED_TRANSACTION_TYPES = ['Bonus']; // Only Bonus is pre-populated

export default function EditTransactionModal({ modalIsOpen, setModalIsOpen, selectedTransaction, defaultDisabledFields = [] }) {

  const { showNotification } = useNotification();
  
  const [formValues, setFormValues] = useState({ amount: '', comments: '', relatedTransactionID: '', id: '', requestTypeID: '', linkedStnPurchaseID: '', transactionTypeID: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '' });
  const [formErrors, setFormErrors] = useState({});
  const { data: transactionTypes, isLoading: transactionTypesIsLoading, isError: transactionTypesIsError, error: transactionTypesError } = useGetTransactionTypesQuery();
  const [editTransactionAdjustment, { data: editedTransaction, isLoading: editTransactionIsLoading, isError: editTransactionIsError, error: editTransactionError }] = useEditTransactionAdjustmentMutation();
  const [relatedTransactionError, setRelatedTransactionError] = useState(false);
  const { data: relatedTransactionInfo, isLoading: relatedTransactionInfoIsLoading, isFetching: relatedTransactionInfoIsFetching, isError: relatedTransactionInfoIsError, error: relatedTransactionInfoError } = useGetTransactionsQuery({ transactionID: formValues.relatedTransactionID }, { skip: !formValues.relatedTransactionID || !modalIsOpen, refetchOnMountOrArgChange: true });
  const {data: requestTypes, isLoading: requestTypesIsLoading, isError: requestTypesIsError, error: requestTypesError} = useRequestTypeQuery();

  function getTransactionTypeName(transactionTypeID) {
    if (!transactionTypeID) return '';
    return transactionTypes.find(transactionType => transactionType.id === transactionTypeID).name;
  }

  useEffect(() => {
    if (selectedTransaction && modalIsOpen && transactionTypes) {
      let transactionTypeId;

      // first try to find transactionType by name
      if (selectedTransaction.transactionType) {
        const foundTypeByName = transactionTypes.find(transactionType =>
          transactionType.name === selectedTransaction.transactionType
        );
        transactionTypeId = foundTypeByName ? foundTypeByName.id : '';
      }

      // if not found, try to find transactionType by id
      if (!transactionTypeId && selectedTransaction.transactionTypeID) {
        const foundTypeById = transactionTypes.find(transactionType =>
          transactionType.id === selectedTransaction.transactionTypeID
        );
        transactionTypeId = foundTypeById ? foundTypeById.id : '';
      }

      setFormValues({
        amount: selectedTransaction.amount !== undefined && selectedTransaction.amount !== null ? selectedTransaction.amount : '',
        comments: selectedTransaction.comments || '',
        relatedTransactionID: selectedTransaction.relatedTransactionID || '',
        id: selectedTransaction.transactionID || selectedTransaction.id || '',
        transactionTypeID: transactionTypeId,
        transactionReasonID: selectedTransaction.transactionReasonID || '',
        notesForBee: selectedTransaction.notesForBee || '',
        notesForAdmin: selectedTransaction.notesForAdmin || '',
        requestTypeID: selectedTransaction.requestTypeID || '',
        linkedStnPurchaseID: selectedTransaction.linkedStnPurchaseID || '',
      });
    }
  }, [selectedTransaction, modalIsOpen, transactionTypes]);

  useEffect(() => {
    if (!formValues.transactionTypeID || !formValues.relatedTransactionID) return;
    if (selectedTransaction.amount !== undefined && selectedTransaction.amount !== null) return;
    if (PRE_POPULATED_TRANSACTION_TYPES.includes(getTransactionTypeName(formValues.transactionTypeID))) {
      setFormValues(prevState => ({
        ...prevState,
        amount: relatedTransactionInfo ? relatedTransactionInfo[0]?.amount : formValues.amount
      }));
    }
  }, [relatedTransactionInfo, formValues.transactionTypeID]);

  useEffect(() => {
    if (!relatedTransactionInfo || !transactionTypes) return;
    if (relatedTransactionInfo.length === 0) {
      setRelatedTransactionError('Related Transaction not found');
    } else if (relatedTransactionInfo.length === 1) {
      if (getTransactionTypeName(relatedTransactionInfo[0].transactionTypeID) !== 'Reward') {
        setRelatedTransactionError('Related Transaction is not a Reward transaction');
      } else {
        setRelatedTransactionError(null);
      }
    } else {
      setRelatedTransactionError(null)
    }

  }, [relatedTransactionInfo, transactionTypes]);

  function handleTransactionSave(formValues) {
    console.log("formValues: ", formValues)
    editTransactionAdjustment(formValues).unwrap()
      .then((res) => {
        console.log(res);
        setModalIsOpen(false);
        showNotification('Transaction saved successfully', 'success');
      })
      .catch((err) => {
        console.log(err);
        showNotification(createErrorMessage(err), 'error');
      });
  }

  const handleCloseTransaction = () => {
    setFormValues({ amount: '', transactionTypeID: '', relatedTransactionID: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', linkedStnPurchaseID: '', requestTypeID: '' });
    setFormErrors({ amount: '', transactionTypeID: '', relatedTransactionID: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', linkedStnPurchaseID: '', requestTypeID: '' });
    setRelatedTransactionError(null);
    setModalIsOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormErrors({ amount: '', comments: '', transactionReasonID: '', notesForBee: '', notesForAdmin: '', relatedTransactionID: '' });
    // This modal only handles transactions of type Reward, Deduction, Bonus, Royalty
    // Penalty transactions are handled by EditErrorTransactionModal
    const addValidationSchema = createAddTransactionValidationSchema(transactionTypes);
    addValidationSchema.validate(formValues, { abortEarly: false })
        .then(() => {
          handleTransactionSave(formValues);
        })
        .catch((err) => {
          const errors = {};
          err.inner.forEach((error) => {
            errors[error.path] = error.message;
          });
          setFormErrors(errors);
        });
  };


  const handleDeleteTransaction = () => {
    console.log("deleting: ", selectedTransaction)
    let editedBonus = {
      "id": selectedTransaction.transactionID || selectedTransaction.id,
      "isDeleted": true
    }
    console.log("editedBonus: ", editedBonus)
    editTransactionAdjustment(editedBonus).unwrap()
      .then((res) => {
        console.log(res);
        setModalIsOpen(false);
        showNotification('Bonus Deleted successfully', 'success');
      })
      .catch((err) => {
        console.log(err);
        setModalIsOpen(false);
        showNotification(createErrorMessage(err), 'error');
      });
  }

  if (transactionTypesIsLoading || requestTypesIsLoading) return <p>Loading...</p>

  // Removed isNonEditableTransactionType function as it always returned false


  function handleRelatedTransactionChange(event) {
    const { name, value: newRelatedTransactionID } = event.target;

    //A: if relatedTransactionId is empty, clean amount and relatedTransactionError
    if (!newRelatedTransactionID) {
      setFormValues(prevState => ({
        ...prevState,
        [name]: newRelatedTransactionID,
        amount: '',
      }));
      setRelatedTransactionError(null);
      return;
    }


    if (!formValues.transactionTypeID) return handleChange(event);
    if (PRE_POPULATED_TRANSACTION_TYPES.includes(getTransactionTypeName(formValues.transactionTypeID))) {
      setFormValues(prevState => ({
        ...prevState,
        [name]: newRelatedTransactionID,
        amount: relatedTransactionInfo ? relatedTransactionInfo[0]?.amount : formValues.amount
      }));
    } else {
      handleChange(event);
    }

  }

  // function beeNotesIsDisabled() {
  //   if (formValues.transactionTypeID) {
  //     let transactionTypeName = transactionTypes.find(transactionType => transactionType.id === formValues.transactionTypeID).name;
  //     if (transactionTypeName != "Penalty") return false;
  //   }
  //   if (!formValues.transactionReasonID) return true;
  //   let transactionReasonSelected = transactionReasons.find(transactionReason => transactionReason.id === formValues.transactionReasonID);
  //   return transactionReasonSelected.name !== 'Other';
  // }

  return (
    <>
      <Modal
        open={modalIsOpen}
        onClose={handleCloseTransaction}
      >
        <Box sx={ModalStyle}>
          <form noValidate onSubmit={handleSubmit}>
            <p style={{ color: 'var(--orange)', margin: '0 0 0.5em 0' }}>Edit Transaction</p>

            <Grid container spacing={2}>

              {/* SELECT TRANSACTION TYPE */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth error={!!formErrors.transactionTypeID}>
                  <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Transaction Type</p>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formValues.transactionTypeID}
                    name="transactionTypeID"
                    onChange={handleChange}
                    sx={{ height: '41px', margin: '0 0 0.5em 0' }}
                    disabled={true}
                  >
                    {transactionTypes.map((transactionType) => (
                      <MenuItem key={transactionType.id} value={transactionType.id}>{transactionType.name == "Penalty" ? "Error" : transactionType.name}</MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>{formErrors.transactionTypeID}</FormHelperText>
                </FormControl>
              </Grid>

              {/* SELECT RequestTypeId (Job Type for user) */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth error={!!formErrors.requestTypeID}>
                  <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Job Type</p> {/* for user request type is job type */}
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formValues.requestTypeID}
                    name="requestTypeID" 
                    onChange={handleChange}
                    sx={{ height: '41px',  margin: '0 0 0.5em 0' }}
                    disabled={formValues.transactionTypeID === "" || transactionTypes.find(transactionType => transactionType.id === formValues.transactionTypeID)?.name !== "Reward"}
                  >
                    {requestTypes.map((requestType) => (
                      <MenuItem key={requestType.id} value={requestType.id}>{requestType.name.replace(/([a-z])([A-Z])/g, '$1 $2') }</MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>{formErrors.requestTypeID}</FormHelperText>
                </FormControl>  
              </Grid>

              {/* Enter Linked StN PurchaseID*/}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Linked StN PurchaseID</p>
                <TextField
                  name="linkedStnPurchaseID"
                  disabled={getTransactionTypeName(formValues.transactionTypeID) !== "Reward" || defaultDisabledFields.includes('linkedStnPurchaseID') }
                  value={formValues.linkedStnPurchaseID}
                  onChange={handleChange}
                  error={!!formErrors.linkedStnPurchaseID}
                  helperText={formErrors.linkedStnPurchaseID}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                />
              </Grid>
              
              {/* SELECT Related Transaction */}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Related Transaction</p>
                <TextField
                  name="relatedTransactionID"
                  required
                  disabled={defaultDisabledFields.includes('relatedTransactionID')}
                  value={formValues.relatedTransactionID}
                  onChange={handleRelatedTransactionChange}
                  error={!!formErrors.relatedTransactionID || relatedTransactionError}
                  helperText={formErrors.relatedTransactionID || relatedTransactionError}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                />
              </Grid>

              {/* Enter AMOUNT */}
              <Grid item xs={12} md={4}>
                <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Amount</p>
                <TextField
                  name="amount"
                  required
                  value={formValues.amount}
                  disabled={defaultDisabledFields.includes('amount')}
                  onChange={handleChange}
                  error={!!formErrors.amount}
                  sx={{ width: '100%', margin: '0 0 0.5em 0' }}
                  helperText={formErrors.amount}
                />
              </Grid>
            </Grid>

            {/* WRITE BEE COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Reason Details (Visible for Bee)</p>
            <TextField
              // disabled={beeNotesIsDisabled()}
              multiline
              rows={4}
              name="notesForBee"
              value={formValues.notesForBee}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForBee}
              helperText={formErrors.notesForBee}
            />

            {/* WRITE ADMIN COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Internal Notes (Visible only for Admins)</p>
            <TextField
              multiline
              rows={4}
              name="notesForAdmin"
              value={formValues.notesForAdmin}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForAdmin}
              helperText={formErrors.notesForAdmin}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button variant='outlined' color='error' sx={{ minWidth: '100px' }} name="deleteButton" onClick={handleDeleteTransaction} disabled={editTransactionIsLoading} >
                Delete
              </Button>
              <div>
                <Button variant='contained' color='secondary' sx={{ minWidth: '100px', margin:'0 1em 0 0' }} name="cancelButton" onClick={handleCloseTransaction}>Cancel</Button>
                <Button variant='contained' type="submit" name="acceptButton" color='primary' sx={{ minWidth: '100px' }} disabled={editTransactionIsLoading} >{editTransactionIsLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Ok"}</Button>
              </div>

            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
}